import React, { useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ProDesk } from './ProDesk';

export const ProDeskContainer = ({ ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="proDesk">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ProDesk {...props} />
    </QueryProvider>
  );
};

ProDeskContainer.propTypes = {};

ProDeskContainer.defaultProps = {};
